export default "__VITE_ASSET__CvH_nL_k__"